import {
  NumberInput,
  NumberInputField,
  NumberInputProps,
  InputRightElement,
  Box,
  InputGroup,
} from '@chakra-ui/react';
import { InputVariant } from 'presentation/theme/components/input';
import { FC, ReactNode } from 'react';

interface AppNumberInputProps extends NumberInputProps {
  postfix?: ReactNode; // Произвольный компонент для отображения справа
}

const AppNumberInput: FC<AppNumberInputProps> = ({ postfix, ...props }) => {
  return (
    <InputGroup>
      <NumberInput
        width="100%"
        variant={InputVariant.filled}
        {...props}
        onChange={(val, numVal) => {
          if (props.onChange && (!isNaN(numVal) || val === '')) {
            props.onChange(val, numVal);
          }
        }}
      >
        <Box position="relative">
          <NumberInputField placeholder={props.placeholder} />
          {postfix && (
            <InputRightElement width="auto" mr={2}>
              {postfix}
            </InputRightElement>
          )}
        </Box>
      </NumberInput>
    </InputGroup>
  );
};

export default AppNumberInput;
